import { render, staticRenderFns } from "./Facets.vue?vue&type=template&id=6bb83760&"
import script from "./Facets.vue?vue&type=script&lang=ts&"
export * from "./Facets.vue?vue&type=script&lang=ts&"
import style0 from "./Facets.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports